import React, { useEffect, useState } from 'react'
import { Box, Button, CircularProgress, Divider, FormControl, TextField, Typography, useTheme } from '@material-ui/core';
import { useTranslation } from '../../contexts/i18n/use'
import makeStyles from '@material-ui/core/styles/makeStyles'
import { Header } from '../header'
import { useConfig } from '../../contexts/config/use';
import { useHistory } from 'react-router-dom';
import { ClearOutdatedStorage } from '../helpers/clearstorage';
import { isFalsyOrEmpty } from '../helpers/object';
import { CheckinModal } from './checkinmodal';
import axios from 'axios'
import { CheckinSpinner } from './checkinspinner';
import { CheckinErrorDialog } from './checkinerrordialog';
import dayjs from 'dayjs'
import { EticketBooking } from '../../services/dto/eticketbooking.dto'
import { useRest } from '../../contexts/rest/use';

export const CheckinPage = () => {
    const { state: { config }, actions: {GetOfficeIDFromUrlID, GetUrlIDFromOfficeID, ReloadConfiguration, GetPrinterData, GetCheckinData, IsOfficeActive}} = useConfig();
    const { state: { wasticketfailure }, actions: { handleTakeBookedTicket, qrToCheckinSelection }} = useRest();
    const { actions: {t, ct, sp}} = useTranslation();
    const [disablebuttons, setDisableButtons] = useState(false);
    const [checkindata, setCheckinData] = useState();
    const [officeid, setOfficeID] = useState();
    const [formdata, setFormData] = useState();
    const [errorstatus, setErrorStatus] = useState("");
    const [modal, setModal] = useState();
    const [submitted, setSubmitted] = useState();
    const [hasloaded, setHasLoaded] = useState();
    const [iswaiting, setIsWaiting] = useState(false);
    const [ispristine, setIsPristine] = useState(true);
    const history = useHistory();
    const theme = useTheme();
    const classes = useStyles(theme);

    useEffect(() => {
      if (config)
      {
        sessionStorage.removeItem("checkinformdata");
  
        var oldbaseurl = localStorage.getItem("baseurl");
        if (window.location.pathname !== oldbaseurl)
        {
          setHasLoaded(false);
          ClearOutdatedStorage();
          localStorage.setItem("baseurl", window.location.pathname);
          ReloadConfiguration();
          window.location.reload();
          return;
        }
  
        const savedticket = JSON.parse(localStorage.getItem("ticket"));
        if (!isFalsyOrEmpty(savedticket) && !savedticket.cancelled)
          history.push("ticket");
        else
        {
          let urlid = GetOfficeIDFromHash();
          if(urlid)
          {
            var result = GetOfficeIDFromUrlID(urlid);
            const data = GetCheckinData(result);
            if (data && data.isActive === true)
              setOfficeID(result);
            else
              history.push("404");
          }
          else
          {
            var result = localStorage.getItem("selectedoffice");
            const data = GetCheckinData(result);
            if (data && data.isActive === true)
              setOfficeID(result);
            else
              history.push("404");
          }
        }
        setHasLoaded(true);
      }
    },[config])

    useEffect(() => {
      if (officeid)
      {
        if (IsOfficeActive(officeid))
        {
          var hash = window.location.hash.split("?")
          window.history.replaceState({}, '', window.location.origin + window.location.pathname + hash[0])
          localStorage.setItem("selectedqueuename", t('checkinpage.checkin'));
          qrToCheckinSelection(officeid);
        }
        else
        {
          localStorage.removeItem("selectedoffice");
          history.push("404");
        }
      }
    }, [officeid])

    useEffect(() => {
      if (!isFalsyOrEmpty(checkindata))
      {
        // We make this check instead of a null-check on checkindata itself
        // Because initally checkindata will always be undefined here
        // But once we return from NQSoapRester with an empty object we can tell if it was a failure or not
        if (isFalsyOrEmpty(checkindata.bookedTime))
        {
          setErrorStatus("failed");
          setIsWaiting(false);
        }
        else
        {
          var isValid = ValidateDate(checkindata.bookedTime.substring(0,19));
          if (isValid)
            takeTicket();
        }
      }
    }, [checkindata]);

    useEffect(() => {
      if (wasticketfailure)
        console.log("wasTicketFailure hapened");
      else 
        setErrorStatus("");
    },[wasticketfailure])

    const ValidateDate = (date) => {
      if (isFalsyOrEmpty(date))
      {
        setErrorStatus("failed");
        setIsWaiting(false);
        return false;
      }
      var bookedDate = dayjs(date);
      var now = dayjs();
      var _checkindata = GetCheckinData(officeid);
      try
      {
        var toLateTime = bookedDate.add(_checkindata.toLateCheckinMinutes, 'minute');
        var toEarlyTime = bookedDate.subtract(_checkindata.toEarlyCheckinMinutes, 'minute');
        if (now.isBefore(toEarlyTime))
        {
          setErrorStatus("toearly");
          setIsWaiting(false);
          return false;
        }
        else if (now.isAfter(toLateTime))
        {
          setErrorStatus("tolate");
          setIsWaiting(false);
          return false;
        }
        else
        {
          setErrorStatus("");
          return true;
        }
      }
      catch(err)
      {
        console.error("Failed to parse eticketbooking time");
        return false;
      }
    }

    const takeTicket = async () => {
      localStorage.setItem("formname", "booking");
      var dt = dayjs(checkindata.bookedTime.substring(0,19)).format(config.dateformat).toString();
      var tickettext = [{id: "appointmenttime" ,value: dt}, {id: "appointmentnumber", value: checkindata.bookingNumber}];
      localStorage.setItem("tickettext", JSON.stringify(tickettext));
      var customertext = t("checkinpage.appointmenttime") + " " + dt.toString() + " & " + t("checkinpage.appointmentnumber") + " " + checkindata.bookingNumber.toString() + " &" + t('checkinpage.numberofpeople') + checkindata.numberOfPeople;
      var printerdata = await GetPrinterData(localStorage.getItem("selectedoffice"));
      localStorage.setItem("isBooking", true);
      localStorage.setItem("selectedqueue", checkindata.unitNumber);
      handleTakeBookedTicket(checkindata, customertext, printerdata.printerNumber);
    }

    const GetOfficeIDFromHash = () => {
      if ( window.location.hash && Object.keys(window.location.hash).length > 0)
      {
        var hashpath = window.location.hash.substr(1);
        var queryparams = hashpath.split('?');
        if (queryparams && queryparams.length > 1)
        {
          var result = queryparams[1].split('=');
          if (result[0] === "officeID")
            return result[1];
          else
            return null;
        }
      }
    }

    const GenerateModal = () => {
      return <CheckinModal data={formdata} cancelcallback={cancelModal} confirmcallback={handleAccept} />
    }

    const GenerateSpinner = () => {
      return <CheckinSpinner />
    }

    const GenerateFailure = (errorstatus) => {
      if (isFalsyOrEmpty(errorstatus))
        return <span/>
      else if (errorstatus === "failed")
        return <CheckinErrorDialog text={sp(t("checkinpage.notfound"), officeid)} cancelcallback={cancelModal} />
      else if (errorstatus === "toearly")
        return <CheckinErrorDialog text={sp(t("checkinpage.toearly"), officeid)} cancelcallback={cancelModal} />
      else if (errorstatus === "tolate")
        return <CheckinErrorDialog text={sp(t("checkinpage.tolate"), officeid)} cancelcallback={cancelModal} />
    }

    const GetData = async (data) => {
      if (!isFalsyOrEmpty(config))
      {
        const checkindata = GetCheckinData(localStorage.getItem("selectedoffice"));
        if (!isFalsyOrEmpty(checkindata))
        {
          await axios.get(config.soapmiddlewareurl + "GetBooking/?id=" + data + 
                          "&orgId=" + checkindata.ventusOrgNumber +
                          "&sectionId=" + checkindata.ventusSection +
                          "&dateTime=" + dayjs().toISOString())
                          .then(res => {
                            if (isFalsyOrEmpty(res.data))
                            {
                              setCheckinData(new EticketBooking(null, null, null, null, null));
                            }
                            else
                            {
                              setCheckinData(new EticketBooking(res.data.bookingNumber, res.data.bookedTime, res.data.queuePosition, res.data.unitNumber, res.data.numberOfPeople))
                            }
          });
        }       
      }            
    }

    const handleSubmit = (e) => {
      e.preventDefault();
      
      if (validate(formdata, false))
      {
        setDisableButtons(true);
        setModal(true);
        setSubmitted(true);
        setIsWaiting(false);
      }
    }
  
    const cancelModal = () => {
      setModal(false);
      setSubmitted(false);
      setDisableButtons(false);
      setIsWaiting(false);
      setErrorStatus("");
    }

    const validate = (value, pristine = true) => {
        if (pristine)
          return true;
        if (!value)
          return false;
        return true;
      }

    const handleChange = (e) => {
      if (config)
      {
        if (config.forbiddenInputs.some(x => e.target.value.includes(x)))
          return;
        if (e.target.value.length > config.maxInputLength)
          return;

        var object = e.target.value;
        setFormData(object);
        setIsPristine(false);
        sessionStorage.setItem("checkinformdata", JSON.stringify(object));
      }
    }

    const handleGoBack = () => {
      sessionStorage.removeItem("checkinformdata");
      localStorage.removeItem("selectedqueuename");
      localStorage.removeItem("selectedqueue");
      const oid = GetUrlIDFromOfficeID(localStorage.getItem("selectedoffice"));
      history.push("queues?officeID=" + oid);
    }

    const handleAccept = () => {
      setIsWaiting(true);
      GetData(formdata);
    }

    if (config)
    {
      return (
          <>
            <Header/>
            <Box className={classes.container}>
              { submitted ? 
                  iswaiting ? 
                  GenerateSpinner()
                  : !isFalsyOrEmpty(errorstatus) ?
                    GenerateFailure(errorstatus)
                    : GenerateModal()
                : <span/> }
              <Typography>
                { ct(officeid, "checkinheader")}
              </Typography>
              <form className={classes.formswrapper} onSubmit={handleSubmit}>
                <FormControl className={classes.formcontrol}>
                  <TextField 
                    disabled={disablebuttons}
                    label={t('checkinpage.formlabel')} 
                    defaultValue={formdata}
                    error={!validate(formdata, ispristine)} 
                    helperText={!validate(formdata, ispristine) && t('checkinpage.incomplete') }
                    required={true} 
                    onChange={(e) => handleChange(e)}
                    className={[classes.textfield, "checkinpage-textbox"].join(' ')}
                    InputProps={{ classes: {root: classes.root, focused: classes.focused}}}
                    inputProps={{title: t('checkinpage.input.errorhelp')}}
                    variant="outlined"
                    size="small"
                    value={formdata}
                    fullWidth={true}
                  />
                </FormControl>
                <Divider variant="middle" className={classes.divider} />
                <Box className={classes.buttonwrapper}>
                  <Button 
                    disabled={disablebuttons}
                    type="button" 
                    classes={{ root: classes.root, disabled: classes.disabled}}
                    className={[classes.button, "dialogbutton"].join(' ')} 
                    id="checkinpage-buttons-back" 
                    onClick={handleGoBack}
                  >
                    {t('checkinpage.backbutton')}
                  </Button>
                  <Button 
                    disabled={disablebuttons || ispristine}
                    type="submit" 
                    classes={{ root: classes.root, disabled: classes.disabled}}
                    className={[classes.button, "dialogbutton"].join(' ')} 
                    id="checkinpage-buttons-submit"
                  >
                    {t('checkinpage.submitbutton')}
                  </Button>
                </Box>
              </form>
        </Box>
          </>
      );
    }
    else
    {
      return (
        <Box className={classes.container}>
          <Box className={classes.formswrapper}>
            <CircularProgress/>
          </Box>
        </Box>
      )
    }
}

const useStyles = makeStyles(theme => ({
    container: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      height: '100%',
      alignItems: 'center',
      overflow: 'auto'
    },
    formswrapper: {
      flex: '1 1 auto',
      display: 'flex',
      width: '100%',
      maxWidth: '600px',
      flexDirection: 'column',
      justifyContent: 'center',
      justifyItems: 'center',
      alignItems: 'center',
      paddingTop: '1rem'
    },
    formcontrol:{
      width: '90%'
    },
    textfield: {
      width: '100%',
      margin: '0.5rem 0'
    },
    button: (theme) => ({
      display: 'inline-block',
      backgroundColor: theme.palette.secondary.main,
      color: theme.palette.button_text.main,
      borderRadius: '0',
      border: 'none',
      [theme.breakpoints.up('lg')]: {
        '&:hover': {
          backgroundColor: 'black',
          color: 'white'
        }
      },
      [theme.breakpoints.down('lg')]: {
        '&:hover': {
          backgroundColor: theme.palette.primary.main,
          color: theme.palette.button_text.main
        }
      }
    }),
    buttonwrapper: {
      display: 'flex',
      flexDirection: 'row',
      padding: '1rem 0',
      justifyContent: 'space-around',
      alignItems: 'center',
      marginTop: 'auto',
      width: '100%'
    },
    divider: {
      marginTop: '0.5rem',
      marginBottom: '0.5rem'
    },
    root: {
      "&$focused": {
        
      },
      "&$disabled": {
        backgroundColor: "gray",
        color: "#f4f4f4"
      }
    },
    disabled: {},
    error: {},
    focused: {}
  }))